function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M247.4,285c-2.7,0-4.9-2.2-4.9-4.9v-51.1c0-7.5-4.8-14.1-11.9-16.5l-15.9-4.8l-27.1,27.1 c-1.9,1.9-5,1.9-6.9,0l-27.1-27.1l-16,4.8c-7,2.3-11.8,8.9-11.8,16.5v51.1c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9v-51.1 c0-11.7,7.5-22.1,18.6-25.7l18.9-5.7c1.7-0.5,3.6,0,4.8,1.2l25.7,25.7l25.7-25.7c1.3-1.3,3.1-1.7,4.8-1.2l18.8,5.6 c11.2,3.7,18.7,14.1,18.7,25.8v51.1C252.2,282.8,250.1,285,247.4,285z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M223.1,285c-2.7,0-4.9-2.2-4.9-4.9v-38.9c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9v38.9 C227.9,282.8,225.7,285,223.1,285z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M145.2,285c-2.7,0-4.9-2.2-4.9-4.9v-38.9c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9v38.9 C150.1,282.8,147.9,285,145.2,285z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M184.1,197.5c-21.5,0-38.9-17.5-38.9-38.9s17.5-38.9,38.9-38.9c21.5,0,38.9,17.5,38.9,38.9 S205.6,197.5,184.1,197.5z M184.1,129.4c-16.1,0-29.2,13.1-29.2,29.2s13.1,29.2,29.2,29.2c16.1,0,29.2-13.1,29.2-29.2 S200.2,129.4,184.1,129.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M291.1,236.4c-2.7,0-4.9-2.2-4.9-4.9v-38.9c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9v38.9 C296,234.2,293.8,236.4,291.1,236.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M252.2,148.8c-21.5,0-38.9-17.5-38.9-38.9S230.8,71,252.2,71s38.9,17.5,38.9,38.9S273.7,148.8,252.2,148.8z  M252.2,80.7c-16.1,0-29.2,13.1-29.2,29.2s13.1,29.2,29.2,29.2s29.2-13.1,29.2-29.2S268.3,80.7,252.2,80.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M77.1,236.4c-2.7,0-4.9-2.2-4.9-4.9v-38.9c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v38.9 C82,234.2,79.8,236.4,77.1,236.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M116.1,148.8c-21.5,0-38.9-17.5-38.9-38.9S94.6,71,116.1,71S155,88.5,155,109.9S137.5,148.8,116.1,148.8z  M116.1,80.7c-16.1,0-29.2,13.1-29.2,29.2s13.1,29.2,29.2,29.2s29.2-13.1,29.2-29.2S132.1,80.7,116.1,80.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.8,236.4c-2.7,0-4.9-2.2-4.9-4.9v-51.1c0-11.7,7.5-22.1,18.6-25.7l18.9-5.7c1.7-0.5,3.6,0,4.8,1.2 l25.7,25.7l25.7-25.7c1.3-1.3,3.1-1.7,4.8-1.2l5,1.5c2.6,0.8,4,3.5,3.3,6.1c-0.8,2.6-3.5,4-6.1,3.3l-2.3-0.7l-27.1,27.1 c-1.9,1.9-5,1.9-6.9,0l-27.1-27.1l-16,4.8c-7,2.3-11.8,8.9-11.8,16.5v51.1C57.7,234.2,55.5,236.4,52.8,236.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M315.5,236.4c-2.7,0-4.9-2.2-4.9-4.9v-51.1c0-7.5-4.8-14.1-11.9-16.5l-15.9-4.8l-27.1,27.1 c-1.9,1.9-5,1.9-6.9,0l-27.1-27.1l-2.3,0.7c-2.6,0.8-5.3-0.7-6.1-3.3c-0.8-2.6,0.7-5.3,3.3-6.1l5-1.5c1.7-0.5,3.6,0,4.8,1.2 l25.7,25.7l25.7-25.7c1.3-1.3,3.1-1.7,4.8-1.2l18.8,5.6c11.2,3.7,18.7,14.1,18.7,25.8v51.1C320.3,234.2,318.2,236.4,315.5,236.4z"
})));

function SvgCommunitySupportCrew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitySupportCrew);
export default __webpack_public_path__ + "static/media/CommunitySupportCrew.7eb6fc4a.svg";
export { ForwardRef as ReactComponent };